import { Component } from '@angular/core';
import { LocalCacheManager } from '../../api/managers/local-cache.manager';
import { Constants } from '../constants';

@Component({
    selector: 'app-whats-new',
    templateUrl: './whats-new.component.html',
    styleUrls: ['./whats-new.component.less']
})
export class WhatsNewComponent
{
    isDontShowChecked = false;
    dontShowButtonImage = Constants.imageWhatsNew.IMG_DONT_SHOW;
    moreInfoButtonImage = Constants.imageWhatsNew.IMG_MORE_INFO;

    constructor(private localCacheManager: LocalCacheManager) { }

    onMouseEnter(button: string)
    {
        if (button === 'dont-show')
        {
            this.dontShowButtonImage = this.isDontShowChecked ? Constants.imageWhatsNew.IMG_DONT_SHOW_HOVER_CHECKED : Constants.imageWhatsNew.IMG_DONT_SHOW_HOVER;
            return;
        }

        this.moreInfoButtonImage = Constants.imageWhatsNew.IMG_MORE_INFO_HOVER;
    }

    onMouseLeave(button: string)
    {
        if (button === 'dont-show')
        {
            this.dontShowButtonImage = this.isDontShowChecked ? Constants.imageWhatsNew.IMG_DONT_SHOW_CHECKED : Constants.imageWhatsNew.IMG_DONT_SHOW;
            return;
        }

        this.moreInfoButtonImage = Constants.imageWhatsNew.IMG_MORE_INFO;
    }

    onToggleCheckbox()
    {
        this.isDontShowChecked = !this.isDontShowChecked;
        this.dontShowButtonImage = this.isDontShowChecked ? Constants.imageWhatsNew.IMG_DONT_SHOW_HOVER_CHECKED : Constants.imageWhatsNew.IMG_DONT_SHOW_HOVER;
        this.localCacheManager.doNotShowWhatsNew = this.isDontShowChecked;
    }

}
